import {OrderByDirection} from '@coolcolduk/firebase-util';
import {JournalSession, JournalSessionDb, mapJournalSessionDbToType} from '@cp/model';
import {QuerySnapshot} from 'firebase/firestore';
import buildFirestoreQuery from '../../helper/firebase/buildFirestoreQuery';
import mapFirestoreDocs from '../../helper/firebase/mapFirestoreDocs';
import type {FirestoreCursor} from '../../types/FirestoreCursor';
import {getJournalSessionCollection} from './getJournalSessionCollection';

export const JOURNAL_SESSIONS_PAGE_SIZE = 10;

export function listJournalSessionsQuery(
  uid: string,
  limit?: number,
  cursor?: FirestoreCursor,
): Promise<QuerySnapshot<JournalSession, JournalSessionDb>> {
  return buildFirestoreQuery(getJournalSessionCollection(uid), {
    order: {field: 'updatedAt', direction: OrderByDirection.DESC},
    ...(cursor ? cursor : {}),
    ...(limit ? {limit} : {}),
  });
}

export default async function listJournalSessions(
  uid: string,
  limit?: number,
  cursor?: FirestoreCursor,
): Promise<JournalSession[]> {
  const snapshot = await listJournalSessionsQuery(uid, limit, cursor);
  return mapFirestoreDocs(snapshot.docs, mapJournalSessionDbToType);
}
